import React from 'react';
import { Button, Modal, ModalProps } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Form, Formik } from 'formik';
import { object, number } from 'yup';

import { FormGroupControl } from '@components/Base';

import { PolicyCommissionInvoiceCreatePayload } from './action';

export type PolicyCommissionInvoiceFormValues = Pick<PolicyCommissionInvoiceCreatePayload, 'totalPremium'>;

const GROUP_PROPS = { className: 'mb-3' };

type FormFormProps = Pick<ModalProps, 'onHide'>;

const FormForm = ({ onHide }: FormFormProps) => {
  const { t } = useTranslation();

  return (
    <Form>
      <Modal.Header closeButton>
        <Modal.Title>New Invoice</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroupControl
          asRow
          type="number"
          label="Total premium"
          name="totalPremium"
          required
          groupProps={GROUP_PROPS}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('confirmModal.cancel')}
        </Button>
        <Button type="submit" variant="primary">
          {t('common:save')}
        </Button>
      </Modal.Footer>
    </Form>
  );
}

type Props = ModalProps & {
  onSubmit: (values: PolicyCommissionInvoiceFormValues) => void;
}

const PolicyCommissionInvoiceFormModal = ({ onSubmit, ...props }: Props) => {
  const { t } = useTranslation();

  const validationSchema = object({
    totalPremium: number().required(t('validation:required')),
  });

  const initialValues: PolicyCommissionInvoiceFormValues = {
    totalPremium: '',
  };

  return (
    <Modal {...props}>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        <FormForm onHide={props.onHide} />
      </Formik>
    </Modal>
  )
};

export { PolicyCommissionInvoiceFormModal };
